import { classIdMap } from './character';

export const TALENT_RINGS = [{
  // DK - Blood
  // Foul Bulwark
  id: 151640,
  classId: classIdMap['Death Knight'],
  spec: 'blood',
  row: 2,
  col: 0,
}, {
  // DK - Frost
  // Gathering Storm
  id: 151640,
  classId: classIdMap['Death Knight'],
  spec: 'frost',
  row: 5,
  col: 0,
}, {
  // DK - Unholy
  // Bursting Sores
  id: 151640,
  classId: classIdMap['Death Knight'],
  spec: 'unholy',
  row: 1,
  col: 0,
}, {

  // DH - Havoc
  // First Blood
  id: 151639,
  classId: classIdMap['Demon Hunter'],
  spec: 'havoc',
  row: 4,
  col: 1,
}, {
  // DH - Vengeance
  // Fallout
  id: 151639,
  classId: classIdMap['Demon Hunter'],
  spec: 'vengeance',
  row: 1,
  col: 1,
}, {

  // Druid - Balance
  // Soul of the Forst
  id: 151636,
  classId: classIdMap.Druid,
  spec: 'balance',
  row: 4,
  col: 0,
}, {
  // Druid - Feral
  // Soul of the Forst
  id: 151636,
  classId: classIdMap.Druid,
  spec: 'feral',
  row: 4,
  col: 0,
}, {
  // Druid - Guardian
  // Soul of the Forst
  id: 151636,
  classId: classIdMap.Druid,
  spec: 'guardian',
  row: 4,
  col: 0,
}, {
  // Druid - Resto
  // Soul of the Forst
  id: 151636,
  classId: classIdMap.Druid,
  spec: 'restoration',
  row: 4,
  col: 0,
}, {

  // Hunter - BM
  // Thrill of the Hunt
  id: 151641,
  classId: classIdMap.Hunter,
  spec: 'beast_mastery',
  row: 3,
  col: 1,
}, {
  // Hunter - MM
  // Lock and Load
  id: 151641,
  classId: classIdMap.Hunter,
  spec: 'marksmanship',
  row: 6,
  col: 1,
}, {
  // Hunter - Survival
  // Viper's Venom
  id: 151641,
  classId: classIdMap.Hunter,
  spec: 'survival',
  row: 0,
  col: 0,
}, {

  // Mage - Arcane
  // Temporal Flux
  id: 151642,
  classId: classIdMap.Mage,
  spec: 'arcane',
  row: 6,
  col: 1,
}, {
  // Mage - Fire
  // Flame On
  id: 151642,
  classId: classIdMap.Mage,
  spec: 'fire',
  row: 3,
  col: 0,
}, {
  // Mage - Frost
  // Frozen Touch
  id: 151642,
  classId: classIdMap.Mage,
  spec: 'frost',
  row: 3,
  col: 0,
}, {

  // Monk - Brewmaster
  // High Tolerance
  id: 151643,
  spec: 'brewmaster',
  classId: classIdMap.Monk,
  row: 6,
  col: 0,
}, {
  // Monk - Mistweaver
  // Mist Wrap
  id: 151643,
  classId: classIdMap.Monk,
  spec: 'mistweaver',
  row: 0,
  col: 0,
}, {
  // Monk - Windwalker
  // Power Strikes
  id: 151643,
  classId: classIdMap.Monk,
  spec: 'windwalker',
  row: 6,
  col: 0,
}, {

  // Paladin - Holy
  // Divine Purpose
  id: 151644,
  classId: classIdMap.Paladin,
  spec: 'holy',
  row: 6,
  col: 0,
}, {
  // Paladin - Protection
  // Holy Shield
  id: 151644,
  classId: classIdMap.Paladin,
  spec: 'protection',
  row: 0,
  col: 0,
}, {
  // Paladin - Retribution
  // Divine Purpose
  id: 151644,
  classId: classIdMap.Paladin,
  spec: 'retribution',
  row: 6,
  col: 0,
}, {

  // Priest - Discipline
  // Twist of Fate
  id: 151646,
  classId: classIdMap.Priest,
  spec: 'discipline',
  row: 0,
  col: 1,
}, {
  // Priest - Holy
  // Surge of Light
  id: 151646,
  classId: classIdMap.Priest,
  spec: 'holy',
  row: 4,
  col: 0,
}, {
  // Priest - Shadow
  // Twist of Fate
  id: 151646,
  classId: classIdMap.Priest,
  spec: 'shadow',
  row: 2,
  col: 0,
}, {

  // Rogue - Assassination
  // Vigor
  id: 150936,
  classId: classIdMap.Rogue,
  spec: 'assassination',
  row: 2,
  col: 0,
}, {
  // Rogue - Outlaw
  // Vigor
  id: 150936,
  classId: classIdMap.Rogue,
  spec: 'outlaw',
  row: 2,
  col: 0,
}, {
  // Rogue - Subtlety
  // Vigor
  id: 150936,
  classId: classIdMap.Rogue,
  spec: 'subtlety',
  row: 2,
  col: 0,
}, {

  // Shaman - Elemental
  // Echo of the Elements
  id: 151647,
  classId: classIdMap.Shaman,
  spec: 'elemental',
  row: 0,
  col: 1,
}, {
  // Shaman - Enhancement
  // Landslide
  id: 151647,
  classId: classIdMap.Shaman,
  spec: 'enhancement',
  row: 1,
  col: 0,
}, {
  // Shaman - Restoration
  // Echo of the Elements
  id: 151647,
  classId: classIdMap.Shaman,
  spec: 'restoration',
  row: 1,
  col: 0,
}, {

  // Warlock - Affliction
  // Soul Conduit
  id: 151649,
  classId: classIdMap.Warlock,
  spec: 'affliction',
  row: 6,
  col: 0,
}, {
  // Warlock - Demonology
  // Soul Conduit
  id: 151649,
  classId: classIdMap.Warlock,
  spec: 'demonology',
  row: 5,
  col: 0,
}, {
  // Warlock - Destruction
  // Eradication
  id: 151649,
  classId: classIdMap.Warlock,
  spec: 'destruction',
  row: 0,
  col: 1,
}, {

  // Warrior - Arms
  // Anger Management
  id: 151650,
  classId: classIdMap.Warrior,
  spec: 'arms',
  row: 6,
  col: 0,
}, {
  // Warrior - Fury
  // Massacre
  id: 151650,
  classId: classIdMap.Warrior,
  spec: 'fury',
  row: 4,
  col: 1,
}, {
  // Warrior - Protection
  // Vengeance
  id: 151650,
  classId: classIdMap.Warrior,
  spec: 'protection',
  row: 5,
  col: 1,
}];
